export default class ModalStack {
  constructor($uibModal, $rootScope) {
    'ngInject';

    Object.assign(this, { $uibModal, $rootScope });
  }

  init() {
    const originalModalOpen = this.$uibModal.open;
    this.modalStack = [];

    const onDisposed = (modal, ...args) => {
      this.$rootScope.$broadcast('closing-modal', ...args);
      const index = this.modalStack.findIndex((m) => m === modal);
      if (index >= 0) {
        this.modalStack.splice(index, 1);
      }
    };

    this.$uibModal.open = (...args) => {
      this.$rootScope.$broadcast('opening-modal', ...args);
      const modal = originalModalOpen.call(this.$uibModal, ...args);
      this.modalStack.push(modal);

      modal.result.ignoreCancel = () => modal.result.catch(() => {});

      const boundDispose = onDisposed.bind(this, modal, ...args);
      // Can't use .finally() because it would cause unhandled rejections
      modal.result.then(boundDispose, boundDispose);
      return modal;
    };
  }

  clear() {
    this.modalStack.forEach((m) => m.dismiss());
    this.modalStack.length = 0;
  }
}
